import { API_ENDPOINTS } from './api-config';

export interface AnthropicEnrichmentRequest {
  prompt: string;
  outputSchema: {
    type: string;
    properties: Record<string, {
      type: string;
      description?: string;
    }>;
  };
  input: Record<string, any>;
}

export interface AnthropicEnrichmentResponse {
  output: {
    content: any;
    basis: Array<{
      confidence: "high" | "medium" | "low";
      reasoning: string;
      field: string;
      citations: Array<{
        tool: string;
        input: any;
      }>;
    }>;
  };
  usage: {
    input_tokens: number;
    output_tokens: number;
  };
}

export async function enrichWithAnthropic(
  request: AnthropicEnrichmentRequest
): Promise<AnthropicEnrichmentResponse> {
  const response = await fetch(API_ENDPOINTS.anthropicEnrich, {
    headers: {
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify(request),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Anthropic enrichment failed: ${response.statusText} - ${errorText}`);
  }

  return await response.json();
}
